











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class FilterButton extends Vue {
  @Prop({ default: false }) active!: boolean;

  toggleFilter() {
    this.$emit('toggleFilter', !this.active);
  }
}
